import qualityEventsHelpers from '../quality-events.helpers';

export const MY_MATERIALS_PAGE_EVENTS = {
    createInteractive() {
        qualityEventsHelpers.track({
            type: 'createNewInteractive'
        });
    },
    createFolderBtn() {
        qualityEventsHelpers.track({
            type: 'create-folder-btn-click'
        });
    },
    folderCreateUpdate(isEdit: boolean) {
        qualityEventsHelpers.track({
            type: isEdit ? 'folder-updated' : 'folder-created'
        });
    },
    archiveMaterials(isMultiSelect: boolean, item: Material, materialIds: number[]) {
        isMultiSelect
            ? qualityEventsHelpers
                  .track({
                      type: 'multiArchiveMaterials',
                      extra: JSON.stringify({ materials: materialIds.length, materialIds })
                  })
                  .finally(() => window.location.reload())
            : qualityEventsHelpers
                  .track({
                      type: 'archiveMaterial',
                      item_id: item.id,
                      item_price: item.finalPrice
                  })
                  .finally(() => window.location.reload());
    },
    removeFolder() {
        qualityEventsHelpers.track({
            type: 'removeFolder'
        });
    },
    unarchiveMaterial(item: Material) {
        qualityEventsHelpers
            .track({
                type: 'unarchiveMaterial',
                item_id: item.id,
                item_price: item.finalPrice
            })
            .finally(() => window.location.reload());
    },
    multiUpdateMaterialsFolders(selectedFolders: number[], materialIds: number[]) {
        qualityEventsHelpers.track({
            type: 'multiUpdateMaterialsFolders',
            extra: JSON.stringify({ folders: selectedFolders.length, materials: materialIds.length })
        });
    },
    updateMaterialFolders(selectedFolders: number[]) {
        qualityEventsHelpers.track({
            type: 'updateMaterialFolders',
            extra: JSON.stringify({ folders: selectedFolders.length })
        });
    },
    materialCardRatingCta(rating: number) {
        qualityEventsHelpers.track({
            type: 'material-card-rating-cta',
            extra: JSON.stringify(rating)
        });
    },
    materialCardReviewStar(isReviewed?: boolean) {
        return qualityEventsHelpers.track({
            type: 'material-card-review-star',
            extra: JSON.stringify({ isReviewed })
        });
    }
};
